import _toConsumableArray from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Creatable from 'react-select/lib/Creatable';
import FieldWrap from '../../FieldWrap/FieldWrap';
import Fetch from '../../../../../services/Fetch';
import Util from '../../../../../services/Util';
import { apiURL } from '../../../../../constants';
import { selectPlaceholder } from '../../../utils/constants';
import { languages } from '../../../../../constants/language';

var CometaSelectComponent = /*#__PURE__*/function (_Component) {
  _inherits(CometaSelectComponent, _Component);

  function CometaSelectComponent() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CometaSelectComponent);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CometaSelectComponent)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      options: []
    }, _this.fetchTimeout = null, _this.cancelableFetch = null, _this._loadOptions = function () {
      var value = _this.props.input.value;
      _this.fetchTimeout = setTimeout(function () {
        _this.cancelableFetch = Util.makeCancelablePromise(!value ? _this.getAllOptions() : _this.getExactOption(value.value).then(function (existingOption) {
          if (!existingOption) {
            return;
          } // fetch all other options


          return _this.getAllOptions().then(function (options) {
            var optionsContainSelectedValue = !!options.find(function (o) {
              return o.code === existingOption.value;
            });

            if (optionsContainSelectedValue) {
              return options;
            }

            return [existingOption].concat(_toConsumableArray(options));
          });
        }));

        _this.cancelableFetch.promise.then(function (options) {
          _this.setState({
            options: options
          });
        });
      }, 200);
    }, _this.getAllOptions = function () {
      var _this$props = _this.props,
          listName = _this$props.listName,
          country = _this$props.country;
      return Fetch.getJSON("".concat(apiURL.API_COMETA, "/").concat(listName, "?country=").concat(country));
    }, _this.getExactOption = function (search) {
      var _this$props2 = _this.props,
          listName = _this$props2.listName,
          country = _this$props2.country;
      return Fetch.getJSON("".concat(apiURL.API_COMETA, "/").concat(listName, "?search=").concat(search, "&exact=true&country=").concat(country));
    }, _this.handleChange = function (option) {
      var _this$props3 = _this.props,
          input = _this$props3.input,
          handleChange = _this$props3.handleChange;
      var value = option && option.value || null; // dispatch to redux store

      input.onChange(value); // save value

      handleChange(value);
    }, _temp));
  } // timeout so we don't fetch immediately on mount
  // promise wrapper that allows canceling promise's success handlers


  _createClass(CometaSelectComponent, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.country !== this.props.country) {
        this._loadOptions();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      return this._loadOptions();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.fetchTimeout);

      if (this.cancelableFetch) {
        this.cancelableFetch.cancel();
      }
    }
  }, {
    key: "getOptionsArray",
    value: function getOptionsArray() {
      var _this$state$options = this.state.options,
          options = _this$state$options === void 0 ? [] : _this$state$options;
      var _this$props4 = this.props,
          language = _this$props4.language,
          sortAlphabetical = _this$props4.sortAlphabetical,
          filterWith = _this$props4.filterWith;

      var generateSortFunc = function generateSortFunc(field) {
        return function (a, b) {
          if (a[field] < b[field]) {
            return -1;
          }

          if (a[field] > b[field]) {
            return 1;
          }

          return 0;
        };
      };

      var adapterOptions = options.map(function (option) {
        var label = option.code;

        if (language === 'en') {
          label = option.title_en;
        }

        if (language === 'es') {
          label = option.title_es;
        }

        if (language === 'pt-BR') {
          label = option.title_pt;
        }

        return _extends({}, option, {
          value: option.code,
          label: label
        });
      }).filter(function (o) {
        return o.label;
      });

      if (filterWith) {
        adapterOptions = adapterOptions.filter(filterWith);
      }

      if (sortAlphabetical && language) {
        var sortBy = generateSortFunc("title_".concat(languages[language].uploadcare));
        adapterOptions = adapterOptions.sort(sortBy);
      }

      return adapterOptions;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          isCreatable = _this$props5.isCreatable,
          isClearable = _this$props5.isClearable,
          input = _this$props5.input,
          label = _this$props5.label,
          displayNotes = _this$props5.displayNotes,
          meta = _this$props5.meta,
          language = _this$props5.language,
          placeholder = _this$props5.placeholder,
          renderOnlySelectComponent = _this$props5.renderOnlySelectComponent,
          classNamePrefix = _this$props5.classNamePrefix,
          id = _this$props5.id;
      var adapterOptions = this.getOptionsArray();
      var value = adapterOptions.find(function (o) {
        return o.value === input.value;
      });
      var ChosenSelectComponent = isCreatable ? Creatable : Select;

      if (renderOnlySelectComponent) {
        return React.createElement(ChosenSelectComponent, {
          isClearable: isClearable,
          id: id,
          value: value,
          options: adapterOptions,
          onChange: this.handleChange,
          onFocus: function onFocus() {
            return input.onFocus();
          },
          onBlur: function onBlur() {
            return input.onBlur();
          },
          placeholder: placeholder || selectPlaceholder[language],
          classNamePrefix: classNamePrefix
        });
      }

      return React.createElement('div', {
        className: 'form-group SelectComponentField'
      }, React.createElement('label', null, label), React.createElement(FieldWrap, {
        meta: meta,
        displayNotes: displayNotes
      }, React.createElement('div', {
        notranslate: 'true'
      }, React.createElement(ChosenSelectComponent, {
        id: id,
        isClearable: isClearable,
        value: value,
        options: adapterOptions,
        onChange: this.handleChange,
        onFocus: function onFocus() {
          return input.onFocus();
        },
        onBlur: function onBlur() {
          return input.onBlur();
        },
        placeholder: placeholder || selectPlaceholder[language]
      }))));
    }
  }]);

  return CometaSelectComponent;
}(Component);

CometaSelectComponent.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  listName: PropTypes.string.isRequired,
  id: PropTypes.string,
  filterWith: PropTypes.func,
  sortAlphabetical: PropTypes.bool,
  renderOnlySelectComponent: PropTypes.bool,
  classNamePrefix: PropTypes.string
};
CometaSelectComponent.defaultProps = {
  isClearable: false,
  isCreatable: false,
  handleChange: Util.noop,
  country: 'INT',
  language: 'en',
  meta: {},
  input: {
    onBlur: Util.noop,
    onFocus: Util.noop,
    onChange: Util.noop
  },
  classNamePrefix: 'SearchableDropdown'
};
export default CometaSelectComponent;